import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/services/dx'

const Dx: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'DX戦略 生成AI PMO イノベーション デジタルトランスフォーメーション'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/services/dx/'}
        title="DX戦略策定 | サービス | i3DESIGN アイスリーデザイン"
        description="クラウド基盤ならびに生成AIといった、テクノロジーを活用した業務効率化・生産性向上・コスト削減を実現するため、DX戦略の策定支援を行います。"
      />
      <Template />
    </>
  )
}

export default Dx
